import { render, staticRenderFns } from "./HomeFavoritesDocuments.vue?vue&type=template&id=101b8a06&"
import script from "./HomeFavoritesDocuments.vue?vue&type=script&lang=js&"
export * from "./HomeFavoritesDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports